export var MobiTalkSource;
(function (MobiTalkSource) {
    MobiTalkSource["D2C"] = "D2C";
    MobiTalkSource["SURE"] = "SURE";
})(MobiTalkSource || (MobiTalkSource = {}));
